<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <p class="Form__tx">
            本登録用のメールを送付しました。<br>
            メールに記載された本登録用URLをクリックすると、<br class="_dsp-none--sp">
            登録フォームに遷移されます。
          </p>
          <div class="_fx _fx-cnter _mg-t45">
            <router-link class="Btn__dotted _ft-spacing" to="/member-register">
              メールが届かない場合はこちら
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import store from '@/store'
import { redirect } from '@/helpers'

export default {
  name: 'SignUpEmailVerify',
  created() {
    this.$store.dispatch('loading/updateLoading', false)
  },
  methods: {
    redirectToLogin() {
      store.dispatch('user/logout')
      redirect('/')
    }
  }
}
</script>
